import clsx from 'clsx'
import React, { useState, useRef, useEffect } from 'react'

import { Icon } from '@/components/Icon'
import { SimpleSelectableOption } from '@/components/Shared/SimpleSelectableOption'
import type {
  CMSCollectionFilter,
  CMSCollectionFilterGroup,
} from '@/types/sanity'

import './FilterGroupMobile.scss'

type Props = {
  filterGroup: CMSCollectionFilterGroup
  isOpen: boolean
  isFilterApplied: ({
    filter,
    filterGroup,
  }: {
    filter: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => boolean
  isFilterAvailable: ({
    filter,
    filterGroup,
  }: {
    filter: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => boolean
  handleFilterChange: ({
    filter,
    filterGroup,
  }: {
    filter?: CMSCollectionFilter
    filterGroup: CMSCollectionFilterGroup
  }) => void
}

export const FilterGroupMobile: React.FC<Props> = ({
  filterGroup,
  isOpen: isOpenInitially,
  isFilterApplied,
  isFilterAvailable,
  handleFilterChange,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenInitially)
  const [maxHeight, setMaxHeight] = useState(isOpenInitially ? 'none' : 0)
  const itemsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isOpen) {
      setMaxHeight(`${itemsRef.current?.scrollHeight}px`)
    } else {
      setMaxHeight(0)
    }
  }, [isOpen])

  const toggleIsOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div
      className={clsx(
        'collection-filter-group-mobile',
        isOpen && 'collection-filter-group-mobile--open',
      )}
    >
      <div
        className="collection-filter-group-mobile__header"
        onClick={toggleIsOpen}
      >
        <span className="collection-filter-group-mobile__header-text type-label">
          {filterGroup.title}
        </span>
        <span className="collection-filter-group-mobile__header-icon">
          <Icon name="chevron" />
        </span>
      </div>
      <div
        className="collection-filter-group-mobile__items"
        ref={itemsRef}
        style={{ maxHeight }}
      >
        {filterGroup.items.map((filter) => (
          <div
            className="collection-filter-group-mobile__item collection-label"
            key={filter._id}
          >
            <SimpleSelectableOption
              id={`${filterGroup._id}-${filter.label}`}
              name={filterGroup.title}
              value={filter.label}
              label={filter.label}
              checked={isFilterApplied({ filter, filterGroup })}
              disabled={!isFilterAvailable({ filter, filterGroup })}
              onClick={() => handleFilterChange({ filter, filterGroup })}
              type="radio"
              styling="borderless"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
